﻿import { LiveDataSet, LiveDataSetValue, Status } from "../../API/LiveData/LiveDataSet";
import { ILiveDataListener } from "../../ILiveDataListener";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { WaveSpectrum, WaveSpectrumComponent } from "../../ValueTypes/WaveSpectrum";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export class PolarWaveChart implements ILiveDataListener {

    private chart: JQuery;
    private stationId: string;

    constructor(page: ISiteObservationsPage, container: JQuery, top: number, left: number, height: number, width: number) {

        this.stationId = page.station.Station.Id;

        var box: JQuery = $('<div class="midi_SiteObservations_chart_container"></div>')
            .css('position', 'absolute')
            .css('top', top + '%')
            .css('left', left + '%')
            .css('height', height + '%')
            .css('width', width + '%');
        
        container.append(box);

        this.chart = $('<div></div>')
            .css('height', '100%')
            .appendTo(box);

        if (page.mainSite.liveDataManager.latestData) {
            this.redrawChart(page.mainSite.liveDataManager.latestData);
        }

    }

    public liveDataChanged(latestData: LiveDataSet): void {
        this.redrawChart(latestData);
    }

    private redrawChart(latestData: LiveDataSet): void {

        this.chart.empty();

        var spectrum: WaveSpectrum = null;
        if (latestData.Stations[this.stationId] && latestData.Stations[this.stationId].GroupValues[ParameterGroupInfoSet.WaveSpectrum.Id]) {

            var val: LiveDataSetValue = latestData.Stations[this.stationId].GroupValues[ParameterGroupInfoSet.WaveSpectrum.Id][0];

            if (val.ExpiryStatus === null || val.ExpiryStatus === Status.Expired) {
                this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
                return;
            }

            spectrum = <WaveSpectrum> val.Value;

        } else {
            this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
            return;
        }

        const periods = [];
        let totalDensity = 0;
        const numberOfDirBins = 16;
        const maxPeriod = 16;

        for (let p = 0; p < maxPeriod; p = p + 2) {

            const single = p >= 2 && p < 6;

            const from = p;
            const to = single ? p + 1 : p + 2;

            const data = [];
            while (data.length < numberOfDirBins) {
                data.push(0);
            }

            periods.push({
                name: from + '-' + to + 's',
                data,
                from,
                to,
            });

            if (single) {
                p--;
            }
        }

        const data = [];
        while (data.length < numberOfDirBins) {
            data.push(0);
        }

        periods.push({
            name: '>' + maxPeriod + 's',
            data,
            from: maxPeriod,
            to: null,
        });

        spectrum.Components.sort((x, y) => y.CentralFrequency - x.CentralFrequency).forEach((component: WaveSpectrumComponent) => {

            const period = Math.min(maxPeriod, 1 / component.CentralFrequency);

            const bin = periods.filter(p => period >= p.from && (p.to == null || period < p.to))[0];
            const dirBinIndex = Math.floor((((component.Direction + (180 / numberOfDirBins)) % 360) / 360) * numberOfDirBins);

            bin.data[dirBinIndex] += component.SpectralDensity;
            totalDensity += component.SpectralDensity;

        });

        for (var i = 0; i < periods.length; i++) {
            if (periods[i].data.reduce((a, b) => a + b, 0) == 0) {
                periods.splice(i);
                i -= 1;
                continue;
            }

            periods[i].data.forEach((x, j) => {
                periods[i].data[j] = x * 100 / totalDensity;
            });
        }

        this.chart.highcharts({
            series: periods,
            chart: {
                polar: true,
                type: 'column',
                marginTop: 30
            },
            exporting: {
                enabled: false
            },
            colors: ['#ff0000', '#ff6600', '#ffff00', '#65ff00', '#00ffd8', '#0099ff', '#0800ff', '#6100ff', '#e100ff', '#ff63c6', '#fad6ff'],
            title: {
                text: ''
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                y: 100,
                layout: 'vertical'
            },
            xAxis: {
                tickmarkPlacement: 'on',
                tickInterval: 22.5,
                min: 0,
                max: 360,
            },
            yAxis: {
                min: 0,
                endOnTick: false,
                showLastLabel: true,
                title: {
                    text: '% of total energy',
                    style: {
                        'color': '#000',
                    }
                },
                labels: {
                    formatter: function () {
                        return this.value + '%';
                    }
                },
                reversedStacks: false
            } as any,
            tooltip: {
                enabled: false
            },
            pane: {
                size: '75%',
                startAngle: 0,
                endAngle: 360
            },
            plotOptions: {
                series: {
                    animation: false,
                    stacking: 'normal',
                    groupPadding: 0,
                    pointPlacement: 'on',
                    pointStart: 0,
                    pointInterval: 22.5,
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    },
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                } as any
            },
            credits: {
                enabled: false
            }
        });
    }
}